module.exports = __webpack_public_path__ + "static/media/deck-c-right.e16a017e.png";